Application.City = {
    ui: {
        form: '.js-form--city',
        submit: '.js-form__submit',
        field: '.js-form__field',
    },
    ready: function () {

        var self = this;

        if (!$(this.ui.form).length){
            return;
        }

        // validate
        $(this.ui.field).change(function(e){
            self.setSubmitState(self.isValid());
        });
        self.setSubmitState(self.isValid());

        // submit
        $(this.ui.submit).click(function(e){
            e.preventDefault();
            self.submit($(this).closest(self.ui.form).attr('action'), $(this).attr('href'));
        });

    },
    submit: function (action, next) {

        if (!this.isValid()){
            return false;
        }

        this.showLoader();

        $.post(action, this.getData(), function(data){
            if (data.result){
                // all done, go to next step
                window.location.href = next;
            }
        }, 'json');

    },
    setSubmitState: function(enabled){

        if (enabled){
            $(this.ui.submit).removeClass('disabled');
        }else{
            $(this.ui.submit).addClass('disabled');
        }

    },
    getData: function(){

        var self = this;
        var data = {};

        $(this.ui.field).each(function(){
            var name = $(this).attr('name');
            if ($(this).is('[type="radio"]')){
                data[name] = $(self.ui.field).filter('[name="' + name + '"]:checked').val();
            } else if ($(this).is('[type="checkbox"]')){
                data[name] = $(this).is(':checked') ? 1 : 0;
            }else{
                data[name] = $(this).val();
            }
        });

        return data;

    },
    isValid: function(){

        var data = this.getData();

        if (!data.city){
            return false;
        }

        return true;

    },
    showLoader: function(){

        $('body').addClass('loading');

    }
};